
import Button from '@/components/NewUiElements/Buttons/Button'
import FoldersMixin from '@/mixins/Folders/FoldersMixin'
import FilesystemPathPart from '@/components/Folders/Path/FilesystemPathPart'
export default {
    name: 'ShowNodeInfoModal',
    components: { FilesystemPathPart, Button },
    mixins: [FoldersMixin],
    props: {
        node: {
            type: Object,
            required: true
        },
        roots: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            loading: true,
            nodeInfo: null
        }
    },
    computed: {
        path () {
            const path = [];
            (this.nodeInfo?.path || []).forEach(p => path.push(p))
            return path
        },
        owner () {
            if (!this.nodeInfo) { return '' }

            if (this.nodeInfo.owner.id === this.$auth.user.id) {
                return 'انا'
            }

            return this.nodeInfo.owner.name
        }
    },
    mounted () {
        this.getNode(this.node, { extra: ['path', 'data', 'owner'] })
            .then(({ data }) => {
                this.nodeInfo = data
            })
            .catch((e) => {
                this.$emit('error', e)
            })
            // eslint-disable-next-line no-return-assign
            .finally(() => this.loading = false)
    },
    methods: {
        formatDate (dateStr) {
            const date = new Date(dateStr)
            const time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
            return `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')} ${time}`
        }
    }
}
